import { useFinanceApi } from 'infrastructure/api';
import { DefaultDropdownProps, LoadDropdown } from 'framework/form';

type VendorOptionDto = {
  id: string;
  vendorName: string;
};

type VendorSearchResponseDto = {
  result: VendorOptionDto[];
  totalPages: number;
};

const PAGE_SIZE = 30;
const FILTER = {
  isCompliant: {
    eq: true,
  },
  workingStatus: {
    eq: 'ACTIVE',
  },
};

const VendorDropdown = ({ source, ...props }: DefaultDropdownProps) => {
  const { sendPostRequest } = useFinanceApi();

  const loadDataMethod = async () => {
    let pageNumber = 0;
    let totalPages = 0;
    const result: VendorOptionDto[] = [];

    do {
      const response = await sendPostRequest('/vendors/search', {
        pageSize: PAGE_SIZE,
        pageNumber,
        filter: FILTER,
      });
      const data: VendorSearchResponseDto = await response.json();

      result.push(...(data.result || []));
      totalPages = data.totalPages || 0;
      pageNumber += 1;
    } while (pageNumber < totalPages);

    return { result };
  };

  return (
    <LoadDropdown
      {...props}
      loadDataMethod={loadDataMethod}
      mapResults={(data: VendorOptionDto) => ({
        value: data.id,
        label: data.vendorName,
      })}
      source={source}
    />
  );
};

export default VendorDropdown;
